


export class SalesFilter {
  public StoreId: number;
  public StatusId: number;
  public ShippingId: number;
  public BrandId: number;
  public CategoryId: number;
  public StartDate: Date;
  public EndDate: Date;
}

export class ReportSale {
  public ProductId: number;
  public ProductName: string;
  public Commission: number;
  public Quantity: number;
  public NetProfit: number;
  public NetSales: number;
}



// WEBPACK FOOTER //
// ./src/app/models/report/sale.model.ts